/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ListaPreguntaMEL } from './listaPreguntaMEL';

export interface ActualizarPreguntasME { 
    usuarioId?: string;
    respuestas?: Array<ListaPreguntaMEL>;
}